import { create } from 'zustand';

const KEY = 'truxsocial:settingsNavCollapsed';

export const useSettingsSidebar = create<{ collapsed: boolean; toggle: () => void }>((set) => {
  let collapsed = false;
  try {
    collapsed = localStorage.getItem(KEY) === '1';
  } catch {
    // Storage can be unavailable; the sidebar still works for this session.
  }
  return {
    collapsed,
    toggle: () =>
      set((state) => {
        const next = !state.collapsed;
        try {
          localStorage.setItem(KEY, next ? '1' : '0');
        } catch {
          // Keep the in-memory preference if persistence is unavailable.
        }
        return { collapsed: next };
      }),
  };
});
